<template>
  <div class="sidebar" :class="{ 'sidebar-mobile-open': mobileMenuOpen }">
    <!-- Logo -->
    <div class="sidebar-header">
      <div class="logo">
        <img src="@/assets/logo.png" alt="QUALI-D" class="logo-icon" />
      </div>
    </div>

    <!-- Navigation -->
    <nav class="sidebar-nav">
      <div class="nav-section">
        <h3 class="nav-section-title">Main</h3>
        <ul class="nav-list">
          <li class="nav-item">
            <router-link :to="isAgent ? '/agent-dashboard' : '/'" class="nav-link" active-class="active">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
                </svg>
              </span>
              <span class="nav-text">Dashboard</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!isAgent">
            <router-link to="/ai-analysis" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2l3.09 6.26L22 9l-5.09.74L12 16l-4.91-6.26L2 9l6.91-1.74L12 2zm0 2.5L9.5 8.5 4 9.5l5.5.5L12 13.5l2.5-3.5L20 9.5l-5.5-1L12 4.5zM12 11.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
                </svg>
              </span>
              <span class="nav-text">AI Analysis</span>
              <span class="nav-badge ai">Smart</span>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="nav-section">
        <h3 class="nav-section-title">Communication</h3>
        <ul class="nav-list">
          <li class="nav-item">
            <router-link to="/whatsapp" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.56-.01-.188 0-.495.074-.754.372-.26.297-.99.967-.99 2.357 0 1.388 1.014 2.731 1.155 2.921.142.19 2.006 3.045 4.848 4.272.678.292 1.207.466 1.621.596.682.217 1.303.187 1.793.113.547-.081 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.051 3.488z"/>
                </svg>
              </span>
              <span class="nav-text">WhatsApp</span>
              <span v-if="whatsappUnreadCount > 0" class="nav-badge danger">{{ whatsappUnreadCount }}</span>
              <span v-else class="nav-badge">Active</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!isAgent">
            <router-link to="/whatsapp-broadcast" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"/>
                </svg>
              </span>
              <span class="nav-text">WhatsApp Broadcast</span>
              <span class="nav-badge new">New</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!isAgent">
            <router-link to="/whatsapp-templates" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M14,17H7V15H14M17,13H7V11H17M17,9H7V7H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"/>
                </svg>
              </span>
              <span class="nav-text">WhatsApp Templates</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!isAgent">
            <router-link to="/agents" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zM4 18v-4h3v4H4zM6 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1 3c-1.1 0-2 .9-2 2v5h2v-5c0-.55.45-1 1-1h4.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H7zm11.5 4.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5S17 17.83 17 17s.67-1.5 1.5-1.5zM20 8.5V7c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1.5c0 .28.22.5.5.5h3c.28 0 .5-.22.5-.5zM12 14c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1z"/>
                </svg>
              </span>
              <span class="nav-text">Agents</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!isAgent">
            <router-link to="/departments" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
                </svg>
              </span>
              <span class="nav-text">Departments</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/messages" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/>
                </svg>
              </span>
              <span class="nav-text">Team Messaging</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!isAgent">
            <router-link to="/escalations" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                </svg>
              </span>
              <span class="nav-text">Escalations</span>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="nav-section">
        <h3 class="nav-section-title">Productivity</h3>
        <ul class="nav-list">
          <li class="nav-item">
            <router-link to="/todo" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
              </span>
              <span class="nav-text">ToDo</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/customers" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zM4 18v-4h3v4H4zM13 12.5h3.5l-1-4.5h-2.5v4.5zM12 13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm0-8c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z"/>
                </svg>
              </span>
              <span class="nav-text">Customers</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/leads" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z"/>
                </svg>
              </span>
              <span class="nav-text">Leads</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="!isAgent">
            <router-link to="/products-services" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z"/>
                </svg>
              </span>
              <span class="nav-text">Products/Services</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="authStore.appointmentMode && !isAgent">
            <router-link to="/appointments" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19,3H18V1H16V3H8V1H6V3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V8H19V19M5,6V5H19V6H5Z"/>
                </svg>
              </span>
              <span class="nav-text">Appointments</span>
              <span class="nav-badge active">Active</span>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="nav-section" v-if="authStore.restaurantMode && !isAgent">
        <h3 class="nav-section-title">Restaurant Mode</h3>
        <ul class="nav-list">
          <li class="nav-item">
            <router-link to="/restaurant-settings" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"/>
                </svg>
              </span>
              <span class="nav-text">Restaurant Settings</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/restaurant-categories" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z"/>
                </svg>
              </span>
              <span class="nav-text">Menu Categories</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/restaurant-menu-items" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"/>
                </svg>
              </span>
              <span class="nav-text">Menu Items</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/restaurant-orders" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z"/>
                </svg>
              </span>
              <span class="nav-text">Orders</span>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="nav-section" v-if="!isAgent">
        <h3 class="nav-section-title">Management</h3>
        <ul class="nav-list">
          <li class="nav-item">
            <router-link to="/payments" class="nav-link">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20,8H4V6C4,4.89 4.89,4 6,4H18A2,2 0 0,1 20,6V8M4,10V18A2,2 0 0,0 6,20H18A2,2 0 0,0 20,18V10H4M16,13.5A1.5,1.5 0 0,1 14.5,12A1.5,1.5 0 0,1 16,10.5A1.5,1.5 0 0,1 17.5,12A1.5,1.5 0 0,1 16,13.5Z"/>
                </svg>
              </span>
              <span class="nav-text">Payments & Billing</span>
            </router-link>
          </li>
          <li class="nav-item dropdown-item" :class="{ expanded: settingsExpanded }">
            <div class="nav-link dropdown-trigger" @click="toggleSettings">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.82,11.69,4.82,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
                </svg>
              </span>
              <span class="nav-text">Settings</span>
              <span class="dropdown-arrow" :class="{ rotated: settingsExpanded }">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                </svg>
              </span>
            </div>
            <ul class="dropdown-menu" v-show="settingsExpanded">
              <li class="dropdown-nav-item">
                <router-link to="/company-profile" class="dropdown-nav-link">
                  <span class="dropdown-nav-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
                    </svg>
                  </span>
                  <span class="dropdown-nav-text">Company Profile</span>
                </router-link>
              </li>
              <li class="dropdown-nav-item">
                <router-link to="/company-leads" class="dropdown-nav-link">
                  <span class="dropdown-nav-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zM4 18v-4h3v4H4zM13 12.5h3.5l-1-4.5h-2.5v4.5zM12 13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm0-8c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z"/>
                    </svg>
                  </span>
                  <span class="dropdown-nav-text">Company Leads</span>
                </router-link>
              </li>
              <li class="dropdown-nav-item">
                <router-link to="/whatsapp-settings" class="dropdown-nav-link">
                  <span class="dropdown-nav-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.485 3.488z"/>
                    </svg>
                  </span>
                  <span class="dropdown-nav-text">WhatsApp Settings</span>
                </router-link>
              </li>
              <li class="dropdown-nav-item">
                <router-link to="/whatsapp-profile" class="dropdown-nav-link">
                  <span class="dropdown-nav-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
                    </svg>
                  </span>
                  <span class="dropdown-nav-text">WhatsApp Profile</span>
                </router-link>
              </li>
              <li class="dropdown-nav-item">
                <router-link to="/zoho-integration" class="dropdown-nav-link">
                  <span class="dropdown-nav-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2l3.09 6.26L22 9l-5.09.74L12 16l-4.91-6.26L2 9l6.91-1.74L12 2zm0 2.5L9.5 8.5 4 9.5l5.5.5L12 13.5l2.5-3.5L20 9.5l-5.5-1L12 4.5zM7 18h10v2H7v-2z"/>
                    </svg>
                  </span>
                  <span class="dropdown-nav-text">Zoho CRM</span>
                </router-link>
              </li>
              <li class="dropdown-nav-item">
                <router-link to="/odoo-integration" class="dropdown-nav-link">
                  <span class="dropdown-nav-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                    </svg>
                  </span>
                  <span class="dropdown-nav-text">Odoo CRM</span>
                </router-link>
              </li>
              <li class="dropdown-nav-item">
                <router-link to="/meta-integration" class="dropdown-nav-link">
                  <span class="dropdown-nav-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </span>
                  <span class="dropdown-nav-text">Meta CAPI</span>
                </router-link>
              </li>
              <li class="dropdown-nav-item">
                <a @click.prevent="openChangePasswordModal" class="dropdown-nav-link" href="#">
                  <span class="dropdown-nav-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
                    </svg>
                  </span>
                  <span class="dropdown-nav-text">Change Password</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="nav-section" v-if="!isAgent">
        <h3 class="nav-section-title">Help & Resources</h3>
        <ul class="nav-list">
          <li class="nav-item dropdown-item" :class="{ expanded: tutorialsExpanded }">
            <div class="nav-link dropdown-trigger" @click="toggleTutorials">
              <span class="nav-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M11,7V13H13V7H11M11,15V17H13V15H11Z"/>
                </svg>
              </span>
              <span class="nav-text">Tutorials</span>
              <span class="dropdown-arrow" :class="{ rotated: tutorialsExpanded }">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                </svg>
              </span>
            </div>
            <ul class="dropdown-menu" v-show="tutorialsExpanded">
              <li class="dropdown-nav-item">
                <a href="https://www.youtube.com/watch?v=RT4Rm66WGco" target="_blank" class="dropdown-nav-link">
                  <span class="dropdown-nav-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                    </svg>
                  </span>
                  <span class="dropdown-nav-text">How To Link Your Whatsapp</span>
                </a>
              </li>
              <li class="dropdown-nav-item">
                <a href="https://www.youtube.com/watch?v=fJo6MfGu__c" target="_blank" class="dropdown-nav-link">
                  <span class="dropdown-nav-icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                    </svg>
                  </span>
                  <span class="dropdown-nav-text">How To Add Products & Services</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>

    <!-- Plan Section -->
    <div class="plan-section">
      <div class="plan-card">
        <div class="plan-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6,2L2,8L12,22L22,8L18,2H6M6.5,4H10.5L11.5,6H8L6.5,4M13.5,4H17.5L16,6H12.5L13.5,4M7.5,8H10.5L12,12L9,8H7.5M11,8H13L12,10L11,8M14.5,8H16.5L15,8L12,12L14.5,8Z"/>
          </svg>
        </div>
        <div class="plan-info">
          <div class="plan-name">{{ userPlan }}</div>
          <div class="plan-label">Current Plan</div>
        </div>
      </div>
    </div>

    <!-- Logout Section -->
    <div class="logout-section">
      <button @click="handleLogout" class="logout-btn">
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
          </svg>
        </span>
        <span class="nav-text">Logout</span>
      </button>
    </div>

    <!-- Change Password Modal -->
    <ChangePasswordModal
      v-if="showChangePasswordModal"
      @close="closeChangePasswordModal"
    />
  </div>
</template>

<script>
import { authStore } from '@/store/auth'
import { DashboardService } from '@/services/dashboard'
import ChangePasswordModal from './ChangePasswordModal.vue'

export default {
  name: 'Sidebar', // eslint-disable-line vue/multi-word-component-names
  components: {
    ChangePasswordModal
  },
  props: {
    isAgent: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mobileMenuOpen: false,
      settingsExpanded: false,
      tutorialsExpanded: false,
      authStore, // Make authStore available to template
      whatsappUnreadCount: 0,
      unreadCountInterval: null,
      agentName: '',
      agentRole: '',
      showChangePasswordModal: false
    }
  },
  computed: {
    userPlan () {
      if (this.isAgent) {
        return this.agentRole || 'Agent'
      }
      return (authStore.user && authStore.user.plan) || 'No Plan'
    }
  },
  watch: {
    // Only update sidebar state when mode actually changes, not on route changes
    'authStore.restaurantMode' () {
      // Mode changed, preserve scroll position
      this.preserveScrollOnNextTick()
    },
    'authStore.appointmentMode' () {
      // Mode changed, preserve scroll position
      this.preserveScrollOnNextTick()
    }
  },
  mounted () {
    // Load agent data if in agent mode
    if (this.isAgent) {
      const agentData = JSON.parse(localStorage.getItem('agent_data') || '{}')
      this.agentName = agentData.name || 'Agent'
      this.agentRole = agentData.agent_role_name || 'Agent'
    }

    // Close mobile menu when clicking outside
    document.addEventListener('click', this.closeMobileMenuOnClickOutside)

    // Listen for custom event to toggle mobile menu
    window.addEventListener('toggleMobileMenu', this.handleMobileMenuToggle)

    // Load initial unread count (only for owners, not agents)
    if (!this.isAgent) {
      this.fetchUnreadCount()

      // Poll for unread count every 30 seconds
      this.unreadCountInterval = setInterval(() => {
        this.fetchUnreadCount()
      }, 30000)
    }

    // Preserve scroll position on route changes
    this.$nextTick(() => {
      const navElement = this.$el.querySelector('.sidebar-nav')
      if (navElement) {
        // Restore scroll position if saved
        const savedScrollPosition = sessionStorage.getItem('sidebar-scroll-position')
        if (savedScrollPosition) {
          navElement.scrollTop = parseInt(savedScrollPosition, 10)
        }

        // Save scroll position on scroll
        navElement.addEventListener('scroll', this.handleNavScroll)
      }
    })
  },
  beforeUnmount () {
    document.removeEventListener('click', this.closeMobileMenuOnClickOutside)
    window.removeEventListener('toggleMobileMenu', this.handleMobileMenuToggle)

    // Clear polling interval
    if (this.unreadCountInterval) {
      clearInterval(this.unreadCountInterval)
    }

    // Clean up scroll listener
    const navElement = this.$el?.querySelector('.sidebar-nav')
    if (navElement) {
      navElement.removeEventListener('scroll', this.handleNavScroll)
    }
  },
  methods: {
    handleNavScroll (event) {
      // Save scroll position to sessionStorage
      sessionStorage.setItem('sidebar-scroll-position', event.target.scrollTop)
    },
    preserveScrollOnNextTick () {
      // When mode changes, preserve scroll position
      const navElement = this.$el?.querySelector('.sidebar-nav')
      if (navElement) {
        const currentScroll = navElement.scrollTop
        this.$nextTick(() => {
          const updatedNavElement = this.$el?.querySelector('.sidebar-nav')
          if (updatedNavElement) {
            updatedNavElement.scrollTop = currentScroll
          }
        })
      }
    },
    async fetchUnreadCount () {
      try {
        const result = await DashboardService.getWhatsAppUnreadCount()
        if (result.success) {
          this.whatsappUnreadCount = result.unreadConversations || 0
        }
      } catch (error) {
        console.error('Error fetching WhatsApp unread count:', error)
      }
    },
    handleMobileMenuToggle () {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    closeMobileMenuOnClickOutside (event) {
      if (window.innerWidth <= 768 && this.mobileMenuOpen) {
        const sidebar = this.$el
        const hamburger = document.querySelector('.menu-toggle')
        if (sidebar && !sidebar.contains(event.target) && !hamburger?.contains(event.target)) {
          this.mobileMenuOpen = false
        }
      }
    },
    toggleSettings () {
      this.settingsExpanded = !this.settingsExpanded
    },
    toggleTutorials () {
      this.tutorialsExpanded = !this.tutorialsExpanded
    },
    openChangePasswordModal () {
      this.showChangePasswordModal = true
    },
    closeChangePasswordModal () {
      this.showChangePasswordModal = false
    },
    handleLogout () {
      if (this.isAgent) {
        console.log('Agent logout clicked from sidebar - clearing agent data...')

        // Clear agent data and auth token
        localStorage.removeItem('agent_token')
        localStorage.removeItem('agent_data')
        localStorage.removeItem('auth_token') // Also clear the owner's token

        console.log('Agent storage cleared, redirecting to agent login...')

        // Navigate to agent login
        this.$router.push('/agent-login')
      } else {
        console.log('Owner logout clicked from sidebar - clearing user data...')

        // Force clear localStorage directly
        localStorage.removeItem('auth_token')
        localStorage.removeItem('user_data')

        // Clear auth store
        authStore.logout()

        console.log('Storage cleared, redirecting to login...')

        // Navigate to login
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 280px;
  height: 100vh;
  background: var(--bg-sidebar);
  border-right: 1px solid var(--border-primary);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  transition: background-color 0.3s ease;
}

.sidebar-header {
  padding: 24px 20px;
  border-bottom: 1px solid var(--border-primary);
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon {
  height: 32px;
  width: auto;
}

.logo-text {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
}

.sidebar-nav {
  flex: 1;
  padding: 20px 0;
  overflow-y: auto;
}

/* Custom Scrollbar Styling */
.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: var(--bg-secondary);
  border-radius: 3px;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: var(--text-tertiary);
  border-radius: 3px;
  transition: background 0.2s;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary);
}

.nav-section {
  margin-bottom: 32px;
}

.nav-section-title {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 20px 12px;
}

.nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  margin: 0;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  color: var(--text-secondary);
  text-decoration: none;
  transition: all 0.2s;
  position: relative;
}

.nav-link:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.nav-item.active .nav-link,
.nav-link.active,
.nav-link.router-link-active {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
  border-right: 3px solid #3b82f6;
}

.nav-icon {
  font-size: 18px;
  width: 20px;
  display: flex;
  justify-content: center;
}

.nav-text {
  font-size: 14px;
  font-weight: 500;
}

.nav-badge {
  margin-left: auto;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  background: #10b981;
  color: white;
}

.nav-badge.new {
  background: #f59e0b;
}

.nav-badge.active {
  background: #10b981;
  animation: pulse 2s infinite;
}

.nav-badge.danger {
  background: #ef4444;
  animation: pulse 2s infinite;
}

.nav-badge.ai {
  background: linear-gradient(135deg, #667eea, #764ba2);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Dropdown Styles */
.dropdown-item {
  position: relative;
}

.dropdown-trigger {
  cursor: pointer;
  position: relative;
}

.dropdown-arrow {
  margin-left: auto;
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
  opacity: 0.7;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.dropdown-menu {
  list-style: none;
  margin: 0;
  padding: 0;
  background: var(--bg-secondary) !important;
  border: 1px solid var(--border-primary);
  border-left: 2px solid rgba(59, 130, 246, 0.3);
  margin-left: 20px;
  margin-top: 4px;
  border-radius: 0 8px 8px 0;
  overflow: hidden;
  animation: slideDown 0.2s ease-out;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    max-height: 200px;
    transform: translateY(0);
  }
}

.dropdown-nav-item {
  margin: 0;
}

.dropdown-nav-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  color: var(--text-secondary) !important;
  background: transparent !important;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 13px;
  position: relative;
}

.dropdown-nav-link:hover {
  background: var(--bg-primary) !important;
  color: var(--text-primary) !important;
  padding-left: 20px;
}

.dropdown-nav-link.router-link-active {
  background: rgba(59, 130, 246, 0.15) !important;
  color: #3b82f6 !important;
  border-right: 2px solid #3b82f6;
}

.dropdown-nav-icon {
  font-size: 14px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropdown-nav-icon svg {
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.dropdown-nav-link:hover .dropdown-nav-icon svg {
  opacity: 1;
}

.dropdown-nav-text {
  font-size: 13px;
  font-weight: 500;
}

/* Expanded state styles */
.dropdown-item.expanded .dropdown-trigger {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.upgrade-card {
  margin: 20px;
  padding: 20px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 16px;
  text-align: center;
  color: white;
}

.upgrade-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.upgrade-card h4 {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
}

.upgrade-card p {
  margin: 0 0 16px;
  font-size: 13px;
  opacity: 0.9;
}

.upgrade-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.upgrade-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Plan Section */
.plan-section {
  margin: 20px;
  margin-bottom: 12px;
}

.plan-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
  padding: 14px 16px;
  border-radius: 8px;
}

.plan-icon {
  font-size: 18px;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.plan-icon svg {
  color: var(--text-primary);
  opacity: 0.9;
}

.plan-info {
  flex: 1;
}

.plan-name {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 2px;
}

.plan-label {
  font-size: 11px;
  opacity: 0.7;
  font-weight: 400;
}

/* Logout Section */
.logout-section {
  margin: 20px;
  margin-top: 8px;
}

.logout-btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2);
}

.logout-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.3);
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
}

.logout-btn:active {
  transform: translateY(0);
}

.logout-btn .nav-icon {
  font-size: 16px;
}

.logout-btn .nav-text {
  flex: 1;
  text-align: left;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    z-index: 2000;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  }

  .sidebar-mobile-open {
    transform: translateX(0);
  }

  .sidebar::before {
    content: '';
    position: fixed;
    top: 0;
    left: 280px;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease-in-out;
  }

  .sidebar-mobile-open::before {
    opacity: 1;
    visibility: visible;
  }

  .nav-section-title {
    font-size: 10px;
  }

  .nav-link {
    padding: 14px 20px;
  }

  .nav-text {
    font-size: 14px;
  }

  .dropdown-menu {
    margin-left: 16px;
  }

  .dropdown-nav-link {
    padding: 8px 12px;
    font-size: 12px;
  }

  .dropdown-nav-text {
    font-size: 12px;
  }

  .plan-section {
    margin: 16px;
    margin-bottom: 8px;
  }

  .plan-card {
    padding: 10px 12px;
  }

  .plan-name {
    font-size: 13px;
  }

  .plan-label {
    font-size: 10px;
  }

  .logout-section {
    margin: 16px;
    margin-top: 8px;
  }
}
</style>
